<template>
  <v-container fluid class="px-7">
    <v-row>
      <v-col cols="12" class="pb-0">
        <v-radio-group
          v-model="acao"
          class="mt-2"
          row
          label="Escolha a ação para este erro:"
          style="font-weight: bolder !important"
        >
          <v-radio label="Corrigir" value="CORRIGIR" />
          <v-radio label="Justificar" value="JUSTIFICAR" />
        </v-radio-group>
      </v-col>
    </v-row>

    <corrigir-erro
      v-if="acao === 'CORRIGIR'"
      :erro="erro"
      :origem-corrigida="origemCorrigida"
      :origem-erro="origemErro"
      @update:origem-corrigida="atualizarOrigemCorrigida"
      @update:origem-erro="origemErro = $event"
      @executada="$emit('executada')"
    />

    <justificar-erro
      v-else-if="acao === 'JUSTIFICAR'"
      :bdgd="bdgd"
      :erro="erro"
      :modo-corrigir-primeiro="true"
      :origem-corrigida="origemCorrigida"
      :origem-erro="origemErro"
      :tarefa="{}"
      @update:origem-corrigida="atualizarOrigemCorrigida"
      @update:origem-erro="origemErro = $event"
      @executada="$emit('executada')"
    />
  </v-container>
</template>

<script>
  import CorrigirErro from './CorrigirErro.vue';
  import JustificarErro from './JustificarErro.vue';
  import routes from '@/store/modules/routes';

  export default {
    name: 'CorrigirPrimeiro',

    components: { CorrigirErro, JustificarErro },

    props: {
      bdgd: {
        type: Object,
        default: () => ({})
      },
      erro: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        acao: 'CORRIGIR',
        origemCorrigida: false,
        origemErro: null
      };
    },

    computed: {
      urlAjustesBdgd() {
        return this.$router.resolve({ name: routes.state.appRoutes.ATUALIZACOES_DE_BDGD }).href;
      }
    },

    methods: {
      atualizarOrigemCorrigida(valor) {
        this.origemCorrigida = Boolean(valor);

        if (!this.origemCorrigida) this.origemErro = null;
      }
    }
  };
</script>

<style scoped>
  .ajustes-bdgd-frame {
    border: 0;
    display: block;
    height: 620px;
    width: 100%;
  }

  @media (max-width: 959px) {
    .ajustes-bdgd-frame {
      height: 520px;
    }
  }
</style>
